"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var mutations = {
  SET_DICT: function SET_DICT(state, dict) {
    state.dict[dict.type] = dict.data;
  }
};
var _default = exports.default = mutations;